module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    attrs: {
      "id": "hrms75e-detail-tab1"
    }
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#tab1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRMS75EC7']['10']) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "tab1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive panel-detail-filter"
  }, [_c('hrms-table', {
    ref: "Tab1",
    attrs: {
      "columns": _vm.detailTab1Columns,
      "data": _vm.detail.table,
      "searchDisp": false,
      "selectRowBool": false,
      "selectBtnDisp": true,
      "selectEvent": _vm.selectEvent,
      "confirmSelectBtnDisp": false
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn bg-color-skin pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.triggerTab1()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['approve']))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78a1fc1c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms75e/detailTab1.vue
// module id = 3899
// module chunks = 1